import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { ConnectedSegmentDate } from '../Segment/SegmentDate';
import { DatePicker } from '../../../components';
import { useSegmentContext } from '../Segment/SegmentManager/Context';
import { CalendarType, CalendarTypeProp } from '../../../models';

export const DateDesktop = ({
    open,
    onChangeFocus,
    placeholderKey,
    isDatesRangeShown,
    roundedCorners,
    type,
}) => {
    const { t } = useTranslation();
    const { segment } = useSegmentContext();
    const { id } = segment;
    return (
        <ConnectedSegmentDate segmentId={id}>
            {({ error, dates, minDate, maxDate, setValue, value }) => (
                <DatePicker
                    value={value}
                    onSelect={setValue}
                    dates={dates}
                    isDatesRangeShown={isDatesRangeShown}
                    minDate={minDate}
                    maxDate={maxDate}
                    placeholder={t(placeholderKey)}
                    validationError={error}
                    open={open}
                    onChangeFocus={onChangeFocus}
                    roundedCornersLast={roundedCorners}
                    type={type}
                />
            )}
        </ConnectedSegmentDate>
    );
};

DateDesktop.propTypes = {
    isDatesRangeShown: PropTypes.bool,
    onChangeFocus: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    placeholderKey: PropTypes.string.isRequired,
    roundedCorners: PropTypes.bool,
    type: CalendarTypeProp,
};

DateDesktop.defaultProps = {
    isDatesRangeShown: false,
    roundedCorners: false,
    type: CalendarType.DEPARTURE,
};
